/* eslint-disable no-unused-vars */

import React, { useCallback, useEffect, useState } from 'react';
import UserService from "../services/user.service";
// import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
// import { Container, Row, Col, Carousel } from 'react-bootstrap';

// import Swiper from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// import vac from "../img/vacation.jpg";
import kido from "../img/forms.jpg"
import leto2025 from "../img/leto2025.jpg"
import springShift from "../img/spring2026.jpeg"

import vac0 from "../img/Ogonek1.jpg";
import vac1 from "../img/vac1.jpg";
import vac2 from "../img/vac2.jpg";
import vac8 from "../img/vac8.jpg";
import vac3 from "../img/vac3.jpg";
import vac4 from "../img/vac4.jpg";
import vac5 from "../img/vac5.jpg";
import vac6 from "../img/vac6.jpg";
import vac7 from "../img/vac7.jpg";
import vac9 from "../img/vac9.jpg";


import zvac0 from "../img/zvac0.jpg";
import zvac1 from "../img/zvac1.jpg";
import zvac2 from "../img/zvac2.jpg";
import zvac3 from "../img/zvac3.jpg";
import zvac4 from "../img/zvac4.jpg";
import zvac5 from "../img/zvac5.jpg";
import zvac6 from "../img/zvac6.jpg";
import zvac7 from "../img/zvac7.jpg";
import zvac8 from "../img/zvac8.jpg";
import zvac9 from "../img/Olimp1.jpg";
import zvac10 from "../img/Ball1.jpg";

import leto1 from "../img/leto25.jpg";
import leto2 from "../img/leto025.jpg";

const VACATION_GALLERY_IMAGES = [
  vac0, vac1, vac2, vac3, vac4, vac5, vac6, vac7, vac8, vac9,
];

const ZVAC_GALLERY_IMAGES = [
  zvac9, zvac10, zvac0, zvac1, zvac2, zvac3, zvac4, zvac5, zvac6, zvac7, zvac8,
];

function Vacation() {

  const [content, setContent] = useState('');
  const [lightbox, setLightbox] = useState(null);

  const closeLightbox = useCallback(() => setLightbox(null), []);

  const openLightbox = useCallback((images, index) => {
    setLightbox({
      images,
      index,
      key: `${Date.now()}-${index}`,
    });
  }, []);

  useEffect(() => {
    if (!lightbox) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closeLightbox();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [lightbox, closeLightbox]);
    useEffect(() => {
    UserService.getPublicContent()
      .then(response => setContent(response.data))
      .catch(error => {
        setContent(
          (error.response && error.response.data) ||
          error.message ||
          error.toString()
        );
      });
  }, []);

  // useEffect(() => {
  //     const swiper = new Swiper('.swiper', {
  //       spaceBetween: 16,
  //       slidesPerView: 3, 
  //       loop: true,
  //       autoHeight: true,
  //       pagination: {
  //         el: '.swiper-pagination',
  //         clickable: true
  //       },
  //       navigation: {
  //         prevEl: '#prev',
  //         nextEl: '#next'
  //       },
  //       breakpoints: {
  //         600: {
  //           slidesPerView: 2
  //         },
  //         1000: {
  //           slidesPerView: 3
  //         }
  //       }
  //     });
  
  //     return () => {
  //       swiper.destroy();
  //     };
  //   }, []);


  // useEffect(() => {
  //   UserService.getPublicContent()
  //     .then(response => {
  //       setContent(response.data);
  //     })
  //     .catch(error => {
  //       setContent(
  //         (error.response && error.response.data) ||
  //           error.message ||
  //           error.toString()
  //       );
  //     });
  // }, []);

  return (
    <div>
    <section className="jarallax dark-mode bg-dark py-5" datajarallax dataspeed="0.6">
    <div className="position-absolute top-0 start-0 w-100 h-100 bg-black opacity-60"></div>
    <div className="jarallax-img" style={{backgroundImage: 'url(assets/img/landing/corporate/anfo.jpg'}}></div>
    <div className="container position-relative zindex-2 pt-5 pb-md-2 pb-lg-3 pb-xl-4 pb-xxl-5">
        <div className="d-lg-flex position-relative h-100" style={{ position: "relative" }}>
          <a className="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 p-0 mt-3 me-3 mt-sm-4 me-sm-4" href="/" data-bs-toggle="tooltip" data-bs-placement="left" title="Back to home"><i className="ai-home"></i></a>
        </div>
      <div className="d-none d-xxl-block" style={{height: "170px"}}></div>
      <div className="d-none d-lg-block d-xxl-none" style={{height: "120px"}}></div>
      <div className="d-none d-md-block d-lg-none" sstyle={{height: "80px"}}></div>
      <div className="d-md-none" style={{height: "40px"}}></div>
      <h1 className="display-2 mb-4">Полезные каникулы.</h1>
      <p className="mb-0 lead text-white" 
    //   style={{maxWidth: "480px"}}
      >
      Каждый раз как начинается новый учебный период дети уже хотят вернуть каникулы обратно. 
      <strong className="lead-bold"> Наша команда</strong> очень ответственно относиться к каникулярному периоду у детей. Перед нами всегда 
      стоит задача <strong className="lead-bold"> грамотно переключить внимание ребенка </strong> после интенсивного учебного периода, 
      необходимо не только развлечь его, но и вложить в игровой форме новые знания и умения.
      {/* <br/> А на данный момент представляем вашему вниманию: */}
        </p>
      {/* Features*/}
      <div className="d-none d-xxl-block" style={{height: "220px"}}></div>
      <div className="d-none d-lg-block d-xxl-none" style={{height: "160px"}}></div>
      <div className="d-none d-md-block d-lg-none" style={{height: "100px"}}></div>
      <div className="d-md-none" style={{height: "50px"}}></div>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4 pb-1 pb-md-3">
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/time-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Индивидуальный подход</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/cog-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Интегрированная аналитика</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/monitor-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Шаг за шагом играй и развивайся</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/size-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Полный спектр услуг: от мастер-классов до питание</h3>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className="container py-4 py-sm-5 my-md-2 my-lg-3 my-xl-4 my-xxl-1">
        <div className="row align-items-center py-4 py-xl-2 my-2">
          <div className="col-md-6 pb-2 mb-2 mb-md-0">
            <img className="rounded-5" src={kido} alt="Ima"/>
            <p></p>
            <br/>
            <p></p>
            {/* <img className="rounded-5" src={teens} alt="Ima"/> */}
          </div>
          <div className="col-md-6 col-xl-5 offset-xl-1">
             <p className="fs-lg"><strong className="h5">Смены городских каникул</strong> в нашем центре «Форматы» 
              <strong className="text-dark"> отличаются по тематике и направлениям,</strong> но в них всегда есть развивающие занятия (английский язык, музыка, 
              шахматы, шашки, уроки на внимание, рисование, лепка и мастер-классы). 
              Полезные каникулы проводим весной, осенью и летом.
              </p>
              <p className="fs-lg mb-2"> Особое внимание мы уделяем и тому, что ест ребенок. <strong className="text-dark">Питание трехразовое, </strong> 
                 в него всегда включены свежие фрукты, выпечка и полный рацион. Если позволяет погода мы всегда гуляем.
              </p>
	              <p className="fs-lg mb-2"> События, которые уже состоялись вы всегда сможете посмотреть в фотогалерее. </p>
	              <p className="fs-lg mb-2">Кстати,<strong className="text-dark">с нами удобно экономить,</strong>  у нас существует система бронирования на каникулы со скидкой.  </p>
	          </div>
            <p></p>
            <br/>
            <p></p>
            <div className="col-12 mt-3 mt-md-4">
              <div className="row align-items-start g-4">
                <div className="col-md-6 col-xl-5 offset-xl-1">
                  <h2 className="h3 mb-3">Весенняя смена для детей 7-9 лет «Тюмень - родной мой край»</h2>
                  <p className="fs-lg mb-3">
                    Весенняя смена поможет детям 7-9 лет открыть для себя историю и культуру родного Тюменского края, воспитывая гордость за малую родину.
                    Программа сочетает творчество, общение и активный отдых для всестороннего развития.
                  </p>
                  <h3 className="h5 mb-2">Цели программы</h3>
                  <p className="fs-lg mb-0">
                    Развивать интерес к истории края, чувство патриотизма, творческие и коммуникативные навыки. Акцент на знакомство с культурой,
                    природой Тюмени, проектной работой и самореализацией.
                  </p>
                </div>
                <div className="col-md-6 pb-2 mb-2 mb-md-0">
                <p></p> <p></p>
                  <img className="rounded-5 w-100" src={springShift} alt="Весенняя смена для детей 7-9 лет"/>
                </div>
              </div>
              <div className="row">
                <div className="col-12 offset-xl-1 mt-4">
                  <h3 className="h5 mb-2">Расписание и условия</h3>
                  <p className="fs-lg mb-2">Место: г. Тюмень, ул. Попова, д. 7 стр. 2</p>
                  <p className="fs-lg mb-2">Время: ежедневно 09:00-18:00.</p>
                  <p className="fs-lg mb-2">Питание: 3-разовое.</p>
                  <p className="fs-lg mb-3">
                    Вечером - развлечения: конкурс талантов, спорт, тематические вечера. Плюс экскурсии по городу и встречи с интересными людьми региона.
                    Регулярно - проекты по культурному наследию Тюмени.
                  </p>
                  <h3 className="h5 mb-2">Что получат дети</h3>
                  <p className="fs-lg mb-3">
                    Познавательный интерес, уважение к традициям, навыки работы в команде и уверенность в себе. Идеально для младших школьников - активное
                    вовлечение через игры, исследования и творчество.
                  </p>
                  <p className="fs-lg mb-2">✔️ Выдаем документы для налогового вычета.</p>
                  <p className="fs-lg mb-2">✔️ Места бронируются предоплатой 50-100%.</p>
                  <p className="fs-lg mb-2">Запись и info: 8(992)300-65-23, 8(992)300-65-46.</p>
                  <p className="fs-lg mb-2">Ждем в «Форматах»!</p>
                </div>
              </div>
            </div>
	          <p></p>
	           <div className="mb-2 p-3">
	            <img className="rounded-5" src={leto2025} alt="leto"/>
	          </div>
          </div>
          <div className="row align-items-center py-2 py-xl-3 my-2">
          <div className="col-md-6 col-xl-5 offset-xl-1">
            <div className="pe-md-4 pe-xl-0">
              <h2 className="h3 pb-2 pb-lg-3">Летний клуб для детей “Олимпия” × “Форматы” 7+, лето 2026! <br/> Активные каникулы для детей: спорт, творчество, новые друзья и яркие впечатления.</h2>
              <p className="pb-2 pb-lg-0 mb-4 mb-lg-5 fs-5">
              Этим летом ребёнка ждёт не просто отдых, а насыщенная программа, где каждый день — это движение, развитие, эмоции и новые открытия.
              <p></p>
              <blockquote className="blockquote">
              <p className="fs-5 text-primary fw-semibold">Зарядись энергией на все лето!</p>
              </blockquote>
              </p>
              <div className="row row-cols-1">
                <div className="col">
                  <p className="fs-5">Почему родители выбирают наши смены:</p>
                  <p className="fs-lg mb-2">✔️ активный день с 09:00 до 18:00</p>
                  <p className="fs-lg mb-2">✔️ спорт, бассейн, творчество и командные игры</p>
                  <p className="fs-lg mb-2">✔️ развитие лидерства, уверенности и самостоятельности</p>
                  <p className="fs-lg mb-2">✔️ полезная занятость ребёнка в каникулы</p>  
                  <p className="fs-lg mb-2">✔️ здоровый образ жизни</p>
                  <p className="fs-lg mb-2">✔️ вкусное питание</p>
                  <p className="fs-lg mb-2">✔️ безопасная и организованная программа</p>
                  <h3 className="h5 mb-2">Тематические смены: </h3>
                  <ul className="fs-lg mb-0">
                    <li>
                      {/* 1 смена  */}
                      <strong> Стражи галактики спорта!</strong> с 1.06 по 12.06  <br/> Эпичная космическая смена для тех, кто мечтает стать сильнее, смелее и увереннее. <br/>
                     Играем, тренируемся, прокачиваем командный дух и раскрываем суперспособности будущих героев. </li>
                    <li> 
                      {/* 2 смена */}
                       <strong> Звёзды Олимпии!</strong> с 15.06 по 26.06  <br/>
                    Лидерская смена, где дети раскрывают свои сильные стороны, таланты и спортивный характер. Больше уверенности, мастерства и ярких побед.
                    </li>
                    <li>
                      {/* 3 смена */}
                       <strong> Супергерои тайги! </strong> с 29.06 по 10.07 <br/> 
                      Уникальный микс спорта и эко-приключений. Природа, командные задания, лидерство, навыки выживания и активный отдых.
                      {/* <br/> О, дорогой Шерлок! Сколько головоломок мы с тобой решим.Хватай шляпу, лупу и отпечатки пальцев, мы идем на дело! */}
                      </li>
                    <li>
                      {/* 4 смена */}
                      <strong> Лидеры спорта!</strong> с 03.08 по 14.08 <br/>
                      Смена для тех, кто готов идти к результату. Про характер, уверенность, дисциплину и успех.  <br/> Главный вопрос этой смены: кто, если не я?<br/>
                      </li>
                  </ul>
                </div> 
                <p></p>
                <div className="col">
                  <p className="fs-5"><strong>Условия участия: </strong><br/> Время посещения: с 09:00 до 18:00. <br/> Формат: городской дневной спортивный клуб.</p>
                  <h3 className="h5 mb-2">
                    {/* Резервные смены:<br/> 16-27 июня, 14-25 июля - открытие записи в мае. <br/> */}
                  Мы находимся по адресу: <br/> МФСЦ «Олимпия», Пржевальского, 37 <br/>
                  Места бронируются по предоплате 50-100%, количество мест ограничено!</h3>
                  <a className="btn m-2" style={{backgroundColor: '#004655'}} href="https://formayou72.s20.online/common/1/form/draw?id=1&baseColor=205EDC&borderRadius=8&css=%2F%2Fcdn.alfacrm.pro%2Flead-form%2Fform.css">Записаться в Лагерь</a>
                  <p></p>
                  <p className="fs-5"><strong>Безопасность — наш приоритет!</strong></p>
                  <p className="fs-5 mb-2"> Мы заботимся о каждом ребёнке: опытные вожатые, педагоги и специалисты следят за безопасностью 24/7. Современные площадки для творчества, квалифицированные специалисты и уютная атмосфера — родители могут быть спокойны!</p>
                  <p className="fs-5 mb-2">Наши смены ведут профессионалы своего дела: тренеры, актёры, эксперты, психологи и педагоги. Занятость ребёнка — 100%: ни минуты скуки, только драйв и развитие!</p>
                  {/* <ul className="fs-lg mb-0">
                    <li>Крутые преподаватели и вожатые</li>
                    <li>Увлекательные уроки (английский язык, музыка, шахматы, шашки, уроки на внимание, рисование, лепка) </li>
                    <li>Отдых на свежем воздухе, игры</li>
                    <li>Мастер-классы по тематике смен</li>
                    <li>Питание 3-х разовое</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-5 offset-xxl-1">
            <div className="mb-4 p-2">
              {/* <img className="rounded-5" src={leto1} alt="lager2025"/> */}
              <img className="rounded-5" src={leto2} alt="lager2025"/>
            </div>
            <h2 className="h3 pb-2 pb-lg-3">До 31 марта действует скидка на ранее бронирование!</h2>
              <p className="pb-2 pb-lg-0 mb-4 mb-lg-3 fs-5">
              <strong> Смены «Форматы» лето 2026: </strong> <br/> Открой таланты, найди друзей, стань героем!: 
              </p>
              <ol className='fs-lg mb-0'>
                <li><strong>Таланты Форматов</strong> - 01.06 по 19.06 <br/>Найди свою уникальную талант-комбинацию! На этой смене каждый участник — звезда! Мы поможем раскрыть способности, попробовать себя в новых ролях и создать свой собственный творческий проект. Личность каждого — уникальна, и мы это ценим!</li> 
                <li> <strong>Богатыри & Царевны: <br/> короли спорта и сцены</strong> - 22.06 по 03.07 <br/>Сказано, захватывающе и современно! Здесь ребята станут настоящими героями: освоят спортивные навыки, научатся выступать на сцене, проявят смелость и смекалку. Легенды оживают в наших играх и квестах!</li> 
                <li> <strong>Путь героя</strong> - 06.07 по 17.07 <br/> Смена про странствия и смелость! Путешествия, испытания, командные игры и поиск сокровищ — всё, чтобы почувствовать себя настоящим героем. Здесь рождаются лидеры и крепкая дружба!</li>
                <li> <strong>VR-миры</strong> - 20.07 по 31.07 <br/> Погружение в будущее! Экскурсии в виртуальной реальности, создание собственных миров и цифровые приключения. Современные технологии в руках юных исследователей! Дети наше будущее!</li>
                <li> <strong>Я — звезда!</strong> - 03.08 по 14.08 <br/> Время блистать! Смена для тех, кто мечтает о сцене, свете софитов и аплодисментах. Театральные мастер-классы, вокал, танцы и съёмки — всё, чтобы почувствовать себя настоящей звездой!</li>
              </ol>
              <p></p>
              <p className="pb-2 pb-lg-0 mb-4 mb-lg-5 fs-5">
              Лето — время открытий, ярких эмоций и настоящих приключений! 
                <br/>
              Мы приглашаем ребят на <strong>уникальные смены «Форматы»</strong>, где каждый день — это новый формат радости, творчества и дружбы. 
              <br/> С нами ваш ребёнок будет в безопасности, занят крутыми делами и окружён вниманием настоящих профессионалов!
              </p>
              <div className="mb-4 p-2">
                <img className="rounded-5" src={leto1} alt="lager2025"/>
            </div>
          </div>
        </div>
        <div className="ps-md-4 pe-xl-0">
          {/* <p className="pb-2 pb-lg-0 mb-4 mb-lg-5 lead">
            С 19 июня до 11 августа! 
          </p> */}
          <div className="row row-cols-1">
            {/* <div className="col"> */}
            <h2 className="h2 pb-2 pb-lg-3">Каникулы в Санкт-Петербурге - <p className="lead">семейное путешествие, которое запомнится надолго.</p></h2> 
            <h3 className="h5 mb-2">Весенние каникулы – это время, когда хочется отвлечься от повседневной рутины, сменить обстановку и провести время с семьей. Предлагаем незабываемый тур в Санкт-Петербург, который подарит вам и вашим детям яркие впечатления, новые знания и теплые воспоминания. </h3>
                  <p className="fs-lg mb-0">Этот тур идеально подходит для родителей, которые хотят:</p>
                  <ul className="fs-lg mb-0 list-unstyled"> 
                    <li>✔️ Провести каникулы с детьми с пользой – каждая экскурсия подобрана так, чтобы детям было интересно, а взрослые открыли для себя новые факты о городе.</li>
                    <li>✔️ Отдохнуть в комфорте – программа включает удобное проживание, питание и организованный трансфер, чтобы не думать о бытовых вопросах.</li>
                    <li>✔️ Создать воспоминания – интерактивные музеи, VR-экскурсии, квесты и прогулки по историческим местам делают путешествие не просто познавательным, а по-настоящему увлекательным.</li>
                  </ul>
                <p></p>
                <p className="h5 mb-2"> Выбирайте удобные даты: <br/>📆 (4 дня) или 📆 (5 дней) </p>
                <p className="h5 mb-2"> Что вас ждет?</p>
                <ul className="fs-lg mb-0 list-unstyled"> 
                    <li>📍 Обзорные экскурсии – увидите лучшие места Петербурга, узнаете интересные факты и легенды.</li>
                    <li>🏛 Знаковые достопримечательности – Эрмитаж, Петропавловская крепость, Кронштадт, Петергоф, Царское Село.</li>
                    <li>🎭 Интерактивные музеи и квесты – «Гранд Макет Россия», Кунсткамера, музей Фаберже, Зоологический музей, музей железных дорог.</li>
                    <li>👓 VR-экскурсии и тематические прогулки – погружение в историю с помощью современных технологий.</li>
                    <li>🍰 Чаепитие в музее Фаберже – возможность не только увидеть уникальные экспонаты, но и насладиться атмосферой Петербурга за чашкой чая с десертом.</li>
                </ul>
                <p></p>
                <p className="h5 mb-2"> Условия тура:</p>
                <ul className="fs-lg mb-0 list-unstyled"> 
                  <li>🏨 Проживание в отелях 3-4 звезды (на выбор).</li>
                  <li>🍽 Питание включено – завтраки, обеды, ужины (в зависимости от тарифа).</li>
                  <li>🚍 Трансфер на автобусе по всей программе.</li>
                  <li>🎟 Входные билеты в музеи уже включены в стоимость.</li> 
                  <li>✈ Скидка 50% на авиабилеты для детей до 11 лет (Nordwind).</li>
                  <li>🚆 Возможность поездки на поезде – дополнительное приключение для детей!</li>
                </ul>
                <p></p>
                <p className="h5 mb-2"> Почему именно этот тур?</p>
                <ul className="fs-lg mb-0 list-unstyled">
                  <li>✔ Готовая программа – вам не нужно ничего планировать, мы уже продумали идеальный маршрут.</li>
                  <li>✔ Комфорт и безопасность – официальное оформление, договор, чеки, бронирования.</li>
                  <li>✔ Оптимальное сочетание экскурсий и свободного времени – насыщенная программа, но без перегруза.</li>
                  <li>✔ Индивидуальный подход – подбираем удобный вариант размещения и учитываем пожелания по питанию.</li>
                </ul>
                <p></p>
                <p className='fs-5'> Стоимость зависит от варианта размещения – количество мест ограничено!</p>
                </div>
            </div>
      </section>
      <section className="container">
        <div className="pt-2 pt-sm-4 pt-lg-2">
        {/* <div className="pb-2"> */}
          <h4 className="mb-lg-3"> Подробности о направлении и наличие мест уточняйте у администратора или Developskillsnow  
              {/* <a className="nav-link fs-lg p-0" href="mailto:developskillsnow@yandex.ru">developskillsnow@yandex.ru</a> */}
              {/* <p className="lead"> */}
            <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://t.me/formayou"><i className="ai-telegram text-danger"> </i> </a>
            <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://t.me/formatyou72"><i className="ai-telegram text-success"> </i> </a>
            <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://www.instagram.com/developskillsnow"><i className="ai-instagram text-warning"> </i> </a> 
            <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/thormayou"><i className="ai-vk text-danger"> </i> </a> 
            <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/developskillsnow"><i className="ai-vk text-primary"> </i> </a> 
          </h4>
            <a className="nav-link fs-lg p-0" href="tel:+7 (992) 300-65-46">Запись на продленку по телефонам: +7 (992) 300-65-46, +7 (992) 300-65-23</a>
        </div>
       </section>

        <section className="z-3 py-2 py-sm-3 py-md-4 py-lg-5">
         <div className="position-relative px-sm-3 px-md-4 px-lg-5">
         <div className="bg-secondary w-100 h-100  p-2" style={{borderTopLeftRadius: '7rem', borderBottomRightRadius: '7rem', width: '100%'}}>
          <br/>
          <p></p>
          <h2 className="text-center mb-4">Наши Коникулы</h2>
         <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={16}
          slidesPerView={3}
          loop={true}
          pagination={{ clickable: true }}
          navigation={true}
          breakpoints={{
            100: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2
            },
            1000: {
              slidesPerView: 3
            }
          }}
          className='p-3 mb-2'
         >
         <br/>
         <p></p>
         <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 0)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 0); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={vac0} alt="Vacation 1" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 1)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 1); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={vac1} alt="Vacation 1" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 2)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 2); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac2} alt="Vacation 2" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 3)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 3); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac3} alt="Vacation 3" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 4)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 4); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac4} alt="Vacation 4" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 5)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 5); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac5} alt="Vacation 5" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 6)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 6); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac6} alt="Vacation 6" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 7)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 7); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac7} alt="Vacation 7" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 8)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 8); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac8} alt="Vacation 8" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(VACATION_GALLERY_IMAGES, 9)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(VACATION_GALLERY_IMAGES, 9); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={vac9} alt="Vacation 0" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <br/>
         <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={16}
          slidesPerView={3}
          loop={true}
          pagination={{ clickable: true }}
          navigation={true}
          breakpoints={{
             100: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2
            },
            1000: {
              slidesPerView: 3
            }
          }}
          className='p-3 mb-2'
        >
        <br/>
        <p></p>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 0)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 0); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={zvac9} alt="Vacation 18" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 1)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 1); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={zvac10} alt="Vacation 18" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 2)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 2); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={zvac0} alt="Vacation 9" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 3)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 3); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={zvac1} alt="Vacation 10" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
            <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 4)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 4); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={zvac2} alt="Vacation 11" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 5)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 5); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={zvac3} alt="Vacation 12" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
            <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 6)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 6); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={zvac4} alt="Vacation 13" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 7)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 7); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={zvac5} alt="Vacation 14" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
            <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 8)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 8); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={zvac6} alt="Vacation 15" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
          <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 9)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 9); } }}>
             <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
              <img src={zvac7} alt="Vacation 16" className="img-fluid" />
              </div>
            </div>
          </SwiperSlide>
            <SwiperSlide className="zoom-effect border-0 rounded-5 overflow-hidden" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }} onClick={() => openLightbox(ZVAC_GALLERY_IMAGES, 10)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(ZVAC_GALLERY_IMAGES, 10); } }}>
            <div className="zoom-effect-wrapper">
              <div className="zoom-effect-img">
                <img src={zvac8} alt="Vacation 17" className="img-fluid" />
               </div>
            </div>
          </SwiperSlide>
        </Swiper>
        </div>
      </div>
  </section>

      {lightbox && (
        <div
          className="vacation-lightbox-backdrop"
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1080,
            backgroundColor: 'rgba(0, 0, 0, 0.92)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '3.5rem 1rem 1rem',
          }}
          onClick={closeLightbox}
          role="presentation"
        >
          <button
            type="button"
            className="btn-close btn-close-white position-fixed top-0 end-0 m-3 m-md-4"
            style={{ zIndex: 1082 }}
            onClick={(e) => {
              e.stopPropagation();
              closeLightbox();
            }}
            aria-label="Закрыть"
          />
          <div
            className="w-100"
            style={{ maxWidth: 'min(1200px, 100%)', height: 'min(85vh, 900px)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <Swiper
              key={lightbox.key}
              modules={[Navigation, Pagination]}
              initialSlide={lightbox.index}
              spaceBetween={24}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={lightbox.images.length > 1}
              className="vacation-lightbox-swiper h-100"
              style={{ height: '100%' }}
            >
              {lightbox.images.map((src, i) => (
                <SwiperSlide key={`${lightbox.key}-${i}`}>
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ height: 'min(80vh, 820px)' }}
                  >
                    <img
                      src={src}
                      alt=""
                      className="img-fluid"
                      style={{
                        maxHeight: 'min(80vh, 820px)',
                        maxWidth: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}

      </div>   
  )
}

export default Vacation;
